import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=51788a2d&scoped=true"
import script from "./FinalStep.vue?vue&type=script&lang=js"
export * from "./FinalStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51788a2d",
  null
  
)

export default component.exports